



































































import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { IObjectNotification } from "@/models/notifications";
import {
  IObjectNotificationsProvider,
  IObjectNotificationsProviderMethods
} from "@/models/providers/objectNotifications";

@Component({
  components: {
    "actions-table-row": () =>
      import("@/components/app/admin/automation/actionTableRow.vue")
  }
})
export default class ObjectNotificationsTable extends Vue {
  // Inject
  @Inject({ from: "objectNotificationsProvider" })
  public readonly $objectNotificationsProvider!: () => IObjectNotificationsProvider;

  public get providerData() {
    return this.$objectNotificationsProvider();
  }

  @Inject({ from: "objectNotificationsProviderMethods" })
  public readonly $providerMethods!: IObjectNotificationsProviderMethods;

  // Props
  @Prop({ required: true })
  public i18n!: {
    emptyMessage: string;
  };

  // Methods
  public mapToActionTableRowTemplate(objectNotification: IObjectNotification) {
    return {
      ...objectNotification.template,
      mappings: [objectNotification]
    };
  }
}
